<template>
  <el-button
    @click="onclick()"
    size="mini"
    round
  >
    {{status ? '收起' : '展开'}}
    <i
      v-if="status"
      class="el-icon-arrow-up"
    />
    <i
      v-else
      class="el-icon-arrow-down"
    />
  </el-button>
</template>
<script>
export default {
  data() {
    return {
      status: false
    }
  },
  props: {
    value: Boolean
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  methods: {
    onclick: function() {
      this.status = !this.status
      this.$emit('update', this.status)
    }
  },
  created() {
    this.status = this.value
  }
}
</script>